import React from 'react';
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import Grid from "@mui/material/Grid";
import FormModal from '../../components/FormModal';
import Button from "@mui/material/Button";
import { startOfWeek, endOfWeek, tomorrow, shiftMonth, dateFormat, textfieldDateFormat } from "../../utils/dateFunctions";
import { getAPIData, getAPIDataParamsReturn, getAPIDataParams } from "../../utils/apiFunction";
import { checkAccess } from '../../utils/roleFunctions';
import { DownloadButton, convertArrayToCSV, convertToCSV } from '../../utils/downloadUtils';
import { useSearchParams } from "react-router-dom";
import { ACCESS, ACCESS_SECTIONS } from '../../utils/constants/access';
import { CircularProgress } from '@mui/material';
import DateSelector from "../../shared/DateSelector";
import IconButton from "@mui/material/IconButton";
import GetAppIcon from '@mui/icons-material/GetApp';
import { fi } from 'date-fns/locale';


const ProcessingDownloads = (props) => {
    const [edit, setEdit] = React.useState(true);
    const [openModal, setOpenModal] = React.useState(false);
    const [reload, setReload] = React.useState(true);
    const requiredEditAccess = { key: ACCESS_SECTIONS.OYSTERMATE, value: ACCESS.EDIT };
    const [searchParams, setSearchParams] = useSearchParams(); // searchParams.get("status")
    const status = (searchParams.get("status"));
    const [forceTask, setForceTask] = React.useState(null);

    //toggle reload function
    const toggleReload = () => {
        setReload(!reload);
    }

    return (<Grid container spacing={4} mb={1} >
        <Grid item xs={12} >
            <ShuckerOutput />

        </Grid>
    </Grid>


    );
};

const ShuckerOutput = (props) => {
    const [data, setData] = React.useState(null);
    const [open, setOpen] = React.useState(null);
    const [startDate, setStartDate] = React.useState(startOfWeek(new Date()));
    const [endDate, setEndDate] = React.useState(tomorrow(endOfWeek(new Date())));
    const [start, setStart] = React.useState(false);
    React.useEffect(() => {
        if (start) {
            setData(null);
            getAPIDataParams('/Processing/DownloadHalfshell', setData, { StartDate: textfieldDateFormat(startDate), EndDate: textfieldDateFormat(endDate) })
        }
    }, [startDate, endDate,start]);

    const convertData = (data) => {
        if (data) {
            var newData = data.map((item) => {
                return {
                    "Firstname": item.firstname,
                    "Sruname": item.surname,
                    "Cut and Turned": item.cutandTurned,
                    "LidOff": item.lidOff,
                    "Popped": item.popped,
                }
            });
            return newData;
        } else {
            return null
        }
    }
    const handleClose = () => {
        setOpen(false)
    };

    return <JumboCardQuick
        title={<span>Shucker Output <div style={{ position: 'absolute', top: '2%', right: '1%' }}>
            <Button variant={'contained'} style={{ marginTop: '10px' }} onClick={() => (setOpen(true))}>Download</Button>

        </div></span>}
        wrapperSx={{
            p: 0,
            backgroundColor: 'background.paper',
            zIndex: 0,
            '&:last-child': {
                pb: 0
            }
        }}
    >
        <FormModal open={open} handleClose={handleClose} title={"Select Date Range"} noWidth >
            <DateSelector startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
            <DownloadButton  start={start} setStart={setStart}  data={convertData(data)}  />
        </FormModal >
    </JumboCardQuick>

}


export default ProcessingDownloads;


